/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RenderBG, CheckLogIn } from './components/index';
import {
  Dashboard,
  SignIn,
  Employees,
  Timesheet,
  Manage,
  UserProfile,
  Forbidden,
  Requests,
  ChatbotPage,
} from './pages/index';
import { RequestNotificationProvider } from './providers/RequestNotificationContext';
import { AlertProvider } from './providers/AlertContext';

const App = () => {
  return (
    <AlertProvider>
      <RequestNotificationProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RenderBG />}>
              <Route index element={<SignIn />} />
            </Route>

            {/* CheckLogIn element is used to check if cookies are valid. */}
            <Route element={<CheckLogIn />}>
              <Route exact path="/dashboard" element={<Dashboard />} />
              <Route exact path="/timesheet" element={<Timesheet />} />
              <Route exact path="/employees" element={<Employees />} />
              <Route exact path="/profile" element={<UserProfile />} />
              <Route exact path="/chatbot" element={<ChatbotPage />} />
              <Route exact path="/manage" element={<Manage />} />
              <Route exact path="/requests" element={<Requests />} />
              <Route exact path="/forbidden" element={<Forbidden />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </RequestNotificationProvider>
    </AlertProvider>
  );
};

export default App;
